module.exports = __webpack_public_path__ + "img/FJ.f34a3bb0.png";